// extracted by mini-css-extract-plugin
module.exports = {"btnsWrap":"Complete_btnsWrap_bNjwe","notice":"Complete_notice_h0ESs","confirmArea":"Complete_confirmArea_GAA2m"};